/**
 * Costanti del reporter di "errori client" — vedi `reviews/errori-client/SPEC.md`.
 * Nessun valore è configurabile da environment: sono limiti di comportamento client, non di rete.
 */

/** Finestra di deduplica per chiave client: ripetizioni della stessa chiave la accumulano. */
export const DEDUP_WINDOW_MS = 60_000;

/** Cadenza dell'invio a batch di quanto accumulato dal dedup. */
export const FLUSH_INTERVAL_MS = 5_000;

/** Oltre questa soglia di elementi pendenti si forza un flush immediato, senza aspettare il timer. */
export const BATCH_SIZE_MAX = 20;

/**
 * Tetto in byte (UTF-8) del JSON serializzato di `errori` in un singolo batch (CORREZIONI-GIRO-2,
 * "Modifiche di contratto"): oltre, si chiude il batch anche sotto i {@link BATCH_SIZE_MAX}
 * elementi. Il limite lato BE è più alto (64 KB sull'intero corpo): questo tetto lascia margine
 * per l'overhead di `app`/`versione_app`/`device_id` e per il 413 residuo, che va comunque diviso.
 */
export const BATCH_SIZE_MAX_BYTES = 48 * 1024;

/** Tetto di chiavi distinte tracciate in memoria per sessione (limite di memoria, non di traffico). */
export const MAX_DISTINCT_KEYS = 200;

/** Tetto di `ripetizioni` accumulabili lato client per una singola chiave (CORREZIONI-GIRO-2). */
export const RIPETIZIONI_MAX = 1000;

/** Tetto della coda offline persistita: oltre, si scartano le voci più vecchie. */
export const OFFLINE_QUEUE_MAX = 50;

export const DEVICE_ID_STORAGE_KEY = 'civeshub.device_id';

export const OFFLINE_QUEUE_STORAGE_KEY = 'civeshub.errori_client.coda_offline';

export const ERRORI_CLIENT_PATH = '/api/v1/errori-client';
